import React from "react";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import "../css/Sidebar.css"
import logo from '../../../assets/img/Baka.png';
import "../../../css/Dash.css"
import { BsCashCoin, BsSpeedometer2 } from "react-icons/bs";
import { PiAddressBookBold } from "react-icons/pi";

function Sidebar() {
  const cookies = new Cookies();

  const cerrarSesion = () => {
    cookies.remove("id", { path: "/" });
    cookies.remove("apellido_paterno", { path: "/" });
    cookies.remove("apellido_materno", { path: "/" });
    cookies.remove("nombre", { path: "/" });
    cookies.remove("username", { path: "/" });
    window.location.href = "./";
  };

  return (
    <div className="sidebar-wrap">
      <div className="sidebar-logo">
        <a href="/menu">
          <img src={logo} alt="Baka Logo" />
        </a>
      </div>

      <ul>
        <li>
          <Link to="/dashboard">
            <BsSpeedometer2 size={18} />
            <label>Dashboard</label>
          </Link>
        </li>
        <li>
          <Link to="/Clientes">
            <PiAddressBookBold size={18} />
            <label>Clientes</label>
          </Link>
        </li>
        <li>
          <Link to="/Prestamos">
            <BsCashCoin size={18} />
            <label>Préstamos</label>
          </Link>
        </li>
      </ul>

      <div className="sidebar-footer">
        <button onClick={cerrarSesion}>Cerrar sesión</button>
      </div>
    </div>
  );
}

export default Sidebar;
